import { useEffect, useState } from 'react';
import { useMaterialsStore } from '../../../components/Stores/MaterialsStore';
import { useAccountStore } from '../../../components/Stores/accountStore';
import { Product } from '../../../sp-types/productType';
import { ProductOverviewDetails } from './ProductOverviewDetails/ProductOverviewDetails';
import { ProductOverviewMaterialBreakdown } from './ProductOverviewMaterials/ProductOverviewMaterials';
import { ProductOverviewSummary } from './ProductOverviewSummary/ProductOverviewSummary';
import { ProductOverviewChart } from './ProductOverviewChart/ProductOverviewChart';
import { ChartViewToolbar } from './ProductOverviewChart/ChartViewToolbar';
import { ChartViewOptions, DataPoint, fetchDataPoints } from './ProductOverviewChart/ProductChartUtils';
import { useAllProducts } from '../../../hooks/useProducts';
import React from 'react';

export interface IProductOverviewPriceStatus {
  focusDate: string;
  productPrice: number;
  materialPrice: number;
  futurePrice: number;
}

const ProductOverview = () => {
  const { account, formulaColorDictionary } = useAccountStore();
  const { data: products } = useAllProducts(account.id);
  const [currentProduct, setCurrentProduct] = useState<Product | undefined>();
  React.useEffect(() => {
    if (products?.length) {
      setCurrentProduct(products[0]);
    }
  }, [products]);

  const [selectedViewOption, setSelectedViewOption] = useState<number>(24);
  const { materialsMap } = useMaterialsStore();
  const [focusedData, setFocusedData] = useState<IProductOverviewPriceStatus>({
    focusDate: 'pick month',
    productPrice: 0,
    futurePrice: 0,
    materialPrice: 0,
  });

  const [chartData, setChartData] = useState<DataPoint[] | null>(null);

  useEffect(() => {
    if (currentProduct && selectedViewOption) {
      fetchDataPoints(currentProduct.id, selectedViewOption).then((resp) => setChartData(resp));
    }
  }, [currentProduct, selectedViewOption]);

  if (!account || !products) {
    return <div> Account Missing</div>;
  }

  const onDataClick = (focusDate: string, productPrice: number, materialPrice: number, futurePrice: number) => {
    setFocusedData({
      focusDate,
      productPrice,
      materialPrice,
      futurePrice,
    });
  };

  return (
    <div className="  flex flex-1 h-full py-8 px-12 overflow-hidden">
      <div className="bg-white flex flex-1 flex-col shadow-md overflow-auto px-10 py-8 space-y-8">
        <div>
          <h4>Product overview</h4>
          <p className="opacity-80">Producer spread overview</p>
        </div>
        <div className="flex space-x-20 h-full">
          <div className="flex flex-col basis-4/5 space-y-4">
            <ProductOverviewDetails
              accountProducts={products}
              currentProduct={currentProduct}
              setCurrentProduct={setCurrentProduct}
            />
            {currentProduct && (
              <>
                <div className="max-w-[35rem]">
                  <ProductOverviewMaterialBreakdown
                    currentProduct={currentProduct}
                    formulaColorDictionary={formulaColorDictionary}
                    materialsMap={materialsMap}
                  />
                </div>
                <div>
                  <ChartViewToolbar
                    viewOptions={ChartViewOptions}
                    selectedValue={selectedViewOption}
                    onSelectionChange={setSelectedViewOption}
                  />
                </div>
                <div className="flex w-full h-full">
                  {chartData && <ProductOverviewChart onDataClick={onDataClick} dataPoints={chartData} />}
                </div>
              </>
            )}
          </div>
          <div className="basis-1/5 space-y-6  flex flex-col h-full justify-end pb-[2rem]">
            <ProductOverviewSummary priceData={focusedData} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProductOverview;
